import CategoryPage from '../page-components/CategoryPage';
import { hydratePageComponent } from './base-script';

hydratePageComponent(CategoryPage);
